<template>
  <div style="padding: 0 10px">
    <Form @search="searchCall" :regionList="regionList"></Form>
    <div style="margin-bottom: 20px; text-align: left">
      <el-button type="primary" @click="createGridCode">批量新增</el-button>
      <el-button type="primary" @click="confirmPrint()">批量打印</el-button>
    </div>
    <WmsTable :columns="columns" :dataSource="dataSource" @pageChange="pageChangeCall" :isRowSelection="true"
      @selectChange="selectChange" :isPagination="query">
      <div slot="action" slot-scope="{ text, record }"
        style="display: flex; justify-content: center; align-items: center">
        <!-- <a href="javascript:;" style="padding: 0 10px" @click="edit(record)"
          >编辑</a
        > -->
        <a href="javascript:;" style="padding: 0 10px" @click="confirmPrint(record)">打印</a>
      </div>
    </WmsTable>
    <SetGridCode ref="SetGridCode" :regionList="regionList" @submit="saveGrids" />
    <el-dialog title="选择打印尺寸" :visible.sync="dialogVisible" width="400px">
      <div>
        <el-radio v-model="templatePrint" label="1">放大版本</el-radio>
        <el-radio v-model="templatePrint" label="2">8cm适用</el-radio>
        <el-radio v-model="templatePrint" label="3">原始版本</el-radio>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="ok">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Form from "@/views/configure/gridCode/components/Form";
import SetGridCode from "@/views/configure/gridCode/components/SetGridCode";
import WmsTable from "@/components/WmsTable";
import { columns } from "@/views/configure/gridCode/indexData";
// 使用已接入现有鉴权和业务拦截器的生成请求入口。
import { request } from "@/config/request/interceptors";
import { templatePrintByGridcode } from "@/utils/print"
export default {
  title: "货格码",
  name: "ConfigureGridCode",
  components: {
    SetGridCode,
    WmsTable,
    Form,
  },
  data() {
    return {
      columns,
      query: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
      dataSource: [],
      regionList: [],
      selList: [],
      fromData: {},
      templatePrint: '1',
      activeRecord: {},
      isBatch: false,
      dialogVisible: false
    };
  },
  mounted() {
    this.getDataSource();
    this.getRegionList();
  },
  methods: {
    /** 搜索条件变更后回到第一页并重新拉取货格码列表。 */
    searchCall: function (fromData) {
      this.fromData = fromData
      this.query.current = 1;
      this.query.total = 1;
      this.getDataSource();
    },
    /** 分页切换后按当前页码和每页条数刷新列表。 */
    pageChangeCall: function (payload) {
      const { current, pageSize } = payload;
      this.query.current = current;
      this.query.pageSize = pageSize;
      this.getDataSource();
    },

    /** 分页查询货格码列表；传入 fromData 时覆盖当前库区筛选。 */
    getDataSource: function (fromData) {
      let params = {
        pageNum: this.query.current,
        pageSize: this.query.pageSize,
        ...this.fromData
      };
      if (fromData) {
        params.regionCode = fromData.regionCode;
      }
      if (params.gridCode) {
        params.gridCode = String(params.gridCode).trim();
      } else {
        delete params.gridCode;
      }
      request.wms.wms.gridGridPage(params).then(({ code, data }) => {
        if (code === '0') {
          this.dataSource = data.records;
          this.query.total = data.total;
        }
      });
    },
    /** 打开批量新增货格码弹窗。 */
    createGridCode: function () {
      this.$refs["SetGridCode"].open();
    },
    /** 单条打印传入当前行；批量打印需先勾选记录，再选择打印尺寸。 */
    confirmPrint(record) {
      if (!record?.id && !this.selList.length) {
        this.$message.warning("请勾选");
        return
      }
      this.activeRecord = record || {}
      this.isBatch = !record?.id
      this.templatePrint = '1'
      this.dialogVisible = true
    },
    /** 按勾选记录批量打印货格码。 */
    printAll: function () {
      templatePrintByGridcode(this.selList, this.templatePrint)
    },
    /** 确认打印尺寸后走批量或单条打印。 */
    ok() {
      if (this.isBatch) {
        this.printAll()
      } else {
        this.printCode(this.activeRecord)
      }
      this.dialogVisible = false
    },
    /** 编辑货格码，当前未开放。 */
    edit: function () {
      this.$message.warning("开发中");
    },
    /** 打印单条货格码。 */
    printCode: function (record) {
      templatePrintByGridcode([record], this.templatePrint)
    },

    /** 批量保存货格码，成功后刷新列表。 */
    saveGrids(r) {
      request.wms.wms.gridSaveGrids(r).then(({ code, data }) => {
        if (code === '0') {
          this.$message.success("添加成功");
          this.getDataSource();
        }
      });
    },

    /** 拉取库区列表，供搜索和批量新增选择所属库区。 */
    getRegionList() {
      request.wms.wms.regionRegionList().then(({ code, data }) => {
        if (code === '0') {
          this.regionList = data;
        }
      });
    },

    /** 记录表格勾选行，供批量打印使用。 */
    selectChange(rows) {
      console.log(rows)
      this.selList = rows
    },
  },
};
</script>

<style scoped></style>
